<template>
	<div>
		<el-form-item :label="presetField.TITLE" ref="formItemPreset" class="is-required">
			<el-select v-if="presetStepType || presetStepFavorite"
			           :value="presetLocation.display_path_first"
			           :placeholder="presetField.PLACEHOLDER"
			           :value-key="'value'"
			           :clearable="true"
			           :filterable="true"
			           remote
			           :remote-method="onSearchPresetLocation"
			           :loading="presetsLoading"
			           :no-match-text="presetEmptyTitle"
			           :no-data-text="presetEmptyTitle"
			           @change="onSelectPresetLocation"
			>
				<el-option
					v-for="item in presetField.ITEMS"
					:key="item.value"
					:label="item.label"
					:value="item.value"
				>
					{{item.display_path_first}} <small>({{item.display_path}})</small>
				</el-option>
			</el-select>
		</el-form-item>

		<el-form-item :prop="fieldProps.CODE" :label="fieldProps.TITLE" :class="afterPropClass" ref="formItem">
			<el-select
			           :value="valueSelect"
			           :placeholder="fieldProps.PLACEHOLDER ? fieldProps.PLACEHOLDER : fieldProps.TITLE"
			           :value-key="'value'"
			           :clearable="true"
			           :filterable="true"
			           remote
			           :remote-method="onSearch"
			           :loading="loading"

			           :no-match-text="labelForSearch"
			           :no-data-text="labelForSearch"
			           @change="onSelectLocation"
			>
				<el-option
					v-for="item in fieldProps.ITEMS ? fieldProps.ITEMS : result.LOCATION"
					:key="item.value"
					:label="item.label"
					:value="item.value"
				>
					{{item.display_path_first}} <small>({{item.display_path}})</small>
				</el-option>
			</el-select>


<!--			<span v-if="useAlternative && isSearched" @click="onUseAlternative"
						      v-html="loc.CITRUS_LOCATION_USE_AS_ALTERNATIVE.replace('#NAME#', searchPhrase)"
						      style="cursor: pointer"></span>
	<div v-if="isUsedAlternative" class="b-location__alternative" @click="onClearAlternative">
				<span class="b-location__alternative_name" v-html="this.searchPhrase"></span>
				&lt;!&ndash;<span class="b-location__alternative_clear" >&times;</span>&ndash;&gt;
			</div>
			<template slot="selected-option" slot-scope="option">
				<span v-show="!isUsedAlternative" class="location_selected" v-html="valueSelect"></span>
			</template>-->
			<slot name="after-prop"></slot>
		</el-form-item>
	</div>
</template>

<script>
import Location from "./Location.vue";

export default {
	name: "LocationByStep",
	mixins: [Location],
	props: {
		presetStepType: {
			type: [Number, String, Boolean],
			default: false,
		},
		presetStepFavorite: {
			type: [Array, Object, Number, String, Boolean],
			default: false,
		},
		presetTitle: {
			type: String,
			default: ""
		},
		presetEmptyTitle: {
			type: String,
			default: "Not found"
		},
		useAlternative: {
			type: Boolean,
			default: false,
		},
		afterPropClass: {
			type: String,
			default: ""
		},
		alternativeSelectedValue: {
			type: String,
			default: ""
		},
		selectedTitle: {
			type: [String, Number],
			default: '',
		},
	},
	watch: {
		alternativeSelectedValue() {
			this.searchPhrase = this.alternativeSelectedValue;
			this.isUsedAlternative = this.alternativeSelectedValue.length > 0;
			this.init();
		}
	},
	data() {
		return {
			isSearched: false,
			isPresetSearched: false,
			searchPhrase: this.alternativeSelectedValue,
			searchPresetPhrase: "",
			isUsedAlternative: this.alternativeSelectedValue.length > 0,

			presetField: {
				CODE: this.fieldProps.CODE + "_PRESET_TYPE",
				IS_LOCATION: this.fieldProps.IS_LOCATION,
				PLACEHOLDER: this.presetTitle,
				REQUIRED: this.fieldProps.REQUIRED,
				ROW_CLASS: this.fieldProps.ROW_CLASS,
				TITLE: this.presetTitle,
				TYPE: this.fieldProps.TYPE,
				ITEMS: [],
			},
			presetLocation: {
				id: 0,
				display_path_first: "",
				value: "",
			},
			presetsLoading: false,

			result: {
				"ERRORS": {},
				"LOCATION": []
			},
			locationsPageN: 0,
			active: false,
			valueSelect: this.selectedTitle,
			valueCode: this.selectedCode,
			inputFocus: false,
			loading: false,
			error: false,
		}
	},
	computed: {
		isPresetFieldError() {
			return this.errors.first(this.presetField.CODE);
		}
	},
	created() {
		this.init();

		if (this.presetStepType || this.presetStepFavorite) {
			this.presetsLoading = true;
			let data = this.prepareAjaxData(false, false, false);

			if (this.presetStepType) {
				data.filter["=TYPE_ID"] = this.presetStepType;
			}
			if (this.presetStepFavorite) {
				data.filter["=CODE"] = this.presetStepFavorite;
			}

			this.ajaxRequest(data, false, "", (result) => {
				this.presetField.ITEMS = this.parseResponseData(result);
				this.presetsLoading = false;
			}, () => {
				this.presetsLoading = false;
			});
		}
	},
	methods: {
		onSelectPresetLocation(location) {
			if (!location) {
				location = {
					id: 0,
					display_path_first: "",
					value: ""
				};
			}
			else {
				for (let item of this.presetField.ITEMS) {
					if (item.value == location) {
						location = item;
						break;
					}
				}
			}

			this.presetLocation = location;
			this.setValueSelect("");

			this.isUsedAlternative = false;
			this.searchPhrase = "";

			this.$emit("location-select", {location: location, selected: ""});
			this.$emit("input", "");
			this.$emit("input-alternative", this.searchPhrase);
			this.result.LOCATION = [];
		},
		onUseAlternative() {
			this.isUsedAlternative = true;

			this.setValueSelect(this.presetLocation.value);
			this.$emit("location-select", {location: this.presetLocation});
			this.$emit("input", this.presetLocation.value);
			this.$emit("input-alternative", this.searchPhrase);
			setTimeout(this.checkValid, 0);
		},
		onClearAlternative() {
			this.isUsedAlternative = false;
			this.isSearched = false;
			this.isPresetSearched = false;
			this.searchPhrase = "";

			this.setValueSelect("");
			this.$emit("location-select", {location: {value: ""}});
			this.$emit("input", "");
			this.$emit("input-alternative", this.searchPhrase);
			this.checkValid();
		},
		onSearchPresetLocation(search) {
			if (search.length <= 2 || !this.isSearch) {
				return;
			}

			this.isUsedAlternative = false;
			this.isPresetSearched = true;
			this.isSearched = false;
			this.searchPresetPhrase = search;

			this.presetsLoading = true;
			let data = this.prepareAjaxData(false, search, false);

			if (this.presetStepType) {
				data.filter["=TYPE_ID"] = this.presetStepType;
			}

			this.ajaxRequest(data, false, "", (result) => {
				this.presetField.ITEMS = this.parseResponseData(result);
				this.presetsLoading = false;
			}, () => {
				this.presetsLoading = false;
			});
		},
		onSearch(search, loading) {
			if (search.length > 2 && this.isSearch) {
				this.isUsedAlternative = false;
				this.isSearched = true;
				this.searchPhrase = search;

				if (loading) {
					loading(true);
				}
				this.search(loading, search);
			}
		},
		onSelectLocation(location) {
			this.isUsedAlternative = false;
			this.searchPhrase = "";
			this.isSearched = false;
			this.isPresetSearched = false;

			if (!location) {
				this.setValueSelect("");
				this.$emit("location-select", {location: {value: ""}, selected: this.valueSelect});
				this.$emit("input", "");
			} else {
				let items = this.fieldProps.ITEMS ? this.fieldProps.ITEMS : this.result.LOCATION;
				for (let item of items) {
					if (item.value == location) {
						location = item;
						break;
					}
				}

				this.setSelectedLocation(location);
			}

			this.$emit("input-alternative", this.searchPhrase);
		},
		search(loading, phrase, code) {
			let data = this.prepareAjaxData(false, phrase, code);
			if (!this.presetLocation.id) {
				return;
			}

			data["filter[=PARENT_ID]"] = this.presetLocation.id;

			this.ajaxRequest(data, loading, code);
		},
		onAjaxSuccess(result, code, loading) {
			let res = this.parseResponseData(result);
			this.result.LOCATION = res;
			if (loading) {
				loading(false);
			}
			this.loading = false;

			if (code && res && res[0]) {
				let location = res[0];

				if (!this.isUsedAlternative) {
					if (location.hasOwnProperty('parent') && location.parent) {
						this.presetLocation = location.parent;
					}

					this.setValueSelect(location)
					this.onSelectLocation(location);
				} else {
					this.presetLocation = location;
					this.setValueSelect(this.presetLocation.value);
					this.$emit("location-select", {location: this.presetLocation});
					this.$emit("input", this.presetLocation.value);
					this.$emit("input-alternative", this.searchPhrase);
				}

				setTimeout(this.checkValid, 0);
			}
		},
		setValueSelect(location) {
			this.valueSelect = typeof location == "string"
				? location
				: location && typeof location == "object" ? location.display_path_first : "";
		}
	}
};
</script>
